import { render } from "./procedure-detail.vue?vue&type=template&id=14fbeb9d"
import script from "./procedure-detail.vue?vue&type=script&lang=js"
export * from "./procedure-detail.vue?vue&type=script&lang=js"

import "./procedure-detail.vue?vue&type=style&index=0&id=14fbeb9d&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__